export const dataGaleria = {
  2026: [
    {
      id: 1,
      titleItem: "Enero",
      children: [
        {
          id: 1,
          nameActivity:
            "“Acciones afirmativas y autoadscripción de la población LGBTTTIQA+ en el marco del Proceso Electoral Local Ordinario 2026-2027 en Tlaxcala”",
          subChilden: [
            { id: 1, alt: "1", link: "1.jpg" },
            { id: 2, alt: "2", link: "2.jpg" },
            { id: 3, alt: "3", link: "3.jpg" },
            { id: 4, alt: "4", link: "4.jpg" },
            { id: 5, alt: "5", link: "5.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity:
            "Agenda de atención a niñas, niños y adolescentes, derivada de los resultados de la Consulta Infantil y Juvenil 2024,",
          subChilden: [
            { id: 6, alt: "6", link: "6.jpg" },
            { id: 7, alt: "7", link: "7.jpg" },
            { id: 8, alt: "8", link: "8.jpg" },
            { id: 9, alt: "9", link: "9.jpg" },
            { id: 10, alt: "10", link: "10.jpg" },
            { id: 11, alt: "11", link: "11.jpg" },
          ],
        },
        {
          id: 3,
          nameActivity:
            "funciones del Sistema Anticorrupción y el uso y manejo de la plataforma digital del Estado",
          subChilden: [
            { id: 12, alt: "12", link: "12.jpg" },
            { id: 13, alt: "13", link: "13.jpg" },
            { id: 14, alt: "14", link: "14.jpg" },
            { id: 15, alt: "15", link: "15.jpg" },
            { id: 16, alt: "16", link: "16.jpg" },
          ],
        },
        {
          id: 3,
          nameActivity:
            "Informe Anual de Actividades 2025 al Congreso del Estado",
          subChilden: [
            { id: 17, alt: "17", link: "17.jpg" },
            { id: 18, alt: "18", link: "18.jpg" },
          ],
        },
      ],
    },
  ],
  
  2025: [
    {
      id: 1,
      titleItem: "Enero",
      children: [
        {
          id: 1,
          nameActivity:
            "apertura de las bodegas electorales para iniciar la desincorporación de la documentación electoral correspondiente a los procesos PELO 2023-2024 y PELE 2024",
          subChilden: [
            { id: 1, alt: "1", link: "1.jpg" },
            { id: 2, alt: "2", link: "2.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity:
            "El 1er Congreso Nacional en materia de Inclusión Tlaxcala 2025",
          subChilden: [
            { id: 3, alt: "3", link: "3.jpg" },
            { id: 4, alt: "4", link: "4.jpg" },
            { id: 5, alt: "5", link: "5.jpg" },
            { id: 6, alt: "6", link: "6.jpg" },
          ],
        },
        {
          id: 3,
          nameActivity:
            "firma de un convenio colaboración entre el Instituto Nacional Electoral y la Asociación Mexicana de Consejeras Estatales Electorales, A. C. (AMCEE",
          subChilden: [
            { id: 7, alt: "7", link: "7.jpg" },
            { id: 8, alt: "8", link: "8.jpg" },
            { id: 9, alt: "9", link: "9.jpg" },
          ],
        },
        {
          id: 4,
          nameActivity:
            "Informe Anual de Actividades 2024 al Congreso del estado",
          subChilden: [
            { id: 10, alt: "10", link: "10.jpg" },
            { id: 11, alt: "11", link: "11.jpg" },
            { id: 12, alt: "12", link: "12.jpg" },
            { id: 13, alt: "13", link: "13.jpg" },
            { id: 14, alt: "14", link: "14.jpg" },
          ],
        },
        {
          id: 5,
          nameActivity: "Primer Congreso Nacional de Inclusión",
          subChilden: [
            { id: 15, alt: "15", link: "15.jpg" },
            { id: 16, alt: "16", link: "16.jpg" },
            { id: 17, alt: "17", link: "17.jpg" },
          ],
        },
        {
          id: 6,
          nameActivity:
            "simulacro de votación que nos permitió analizar a fondo diversos aspectos técnicos de cara a la próxima elección judicial local 2025",
          subChilden: [
            { id: 18, alt: "18", link: "18.jpg" },
            { id: 19, alt: "19", link: "19.jpg" },
            { id: 20, alt: "20", link: "20.jpg" },
          ],
        },
      ],
    },
    {
      id: 2,
      titleItem: "Febrero",
      children: [
        {
          id: 1,
          nameActivity:
            "elección de la reina de la primavera del ciclo escolar 2024-2025",
          subChilden: [
            { id: 21, alt: "21", link: "21.jpg" },
            { id: 22, alt: "22", link: "22.jpg" },
            { id: 23, alt: "23", link: "23.jpg" },
            { id: 24, alt: "24", link: "24.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity:
            "Primer Concurso de Debate Universitario 2025",
          subChilden: [
            { id: 25, alt: "25", link: "25.jpg" },
            { id: 26, alt: "26", link: "26.jpg" },
            { id: 27, alt: "27", link: "27.jpg" },
            { id: 28, alt: "28", link: "28.jpg" },
          ],
        },
      ],
    },
    {
      id: 3,
      titleItem: "Marzo",
      children: [
        {
          id: 1,
          nameActivity:
            "capacitación con las candidaturas que participarán en la elección de cargos del Tribunal Superior de Justicia y de los tribunales de Conciliación y Arbitraje, de Justicia Administrativa y de",
          subChilden: [
            { id: 29, alt: "29", link: "29.jpg" },
            { id: 30, alt: "30", link: "30.jpg" },
            { id: 31, alt: "31", link: "31.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity:
            "Derechos politico-electorales de las mujeres en el ejercicio del cargo, avances y retos”",
          subChilden: [
            { id: 32, alt: "32", link: "32.jpg" },
            { id: 33, alt: "33", link: "33.jpg" },
            { id: 34, alt: "34", link: "34.jpg" },
            { id: 35, alt: "35", link: "35.jpg" },
          ],
        },
        {
          id: 3,
          nameActivity:
            "Innovación en materia de capacitación, formación de ciudadanía y promoción a los derechos humanos de las mujeres en el ámbito político",
          subChilden: [
            { id: 36, alt: "36", link: "36.jpg" },
            { id: 37, alt: "37", link: "37.jpg" },
            { id: 38, alt: "38", link: "38.jpg" },
            { id: 39, alt: "39", link: "39.jpg" },
          ],
        },
        {
          id: 4,
          nameActivity:
            "Procesos de representación política en comunidades tlaxcaltecas regidas por usos y costumbres",
          subChilden: [
            { id: 40, alt: "40", link: "40.jpg" },
            { id: 41, alt: "41", link: "41.jpg" },
            { id: 42, alt: "42", link: "42.jpg" },
          ],
        },
      ],
    },
    {
      id: 4,
      titleItem: "Abril",
      children: [
        {
          id: 1,
          nameActivity:
            "“Difusión y promoción de los derechos políticos electorales desde una perspectiva pluricultural”",
          subChilden: [
            { id: 43, alt: "43", link: "43.jpg" },
            { id: 44, alt: "44", link: "44.jpg" },
            { id: 45, alt: "45", link: "45.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity:
            "arranque entre la empresa Informática Electoral y el Instituto Tlaxcalteca de Elecciones",
          subChilden: [
            { id: 46, alt: "46", link: "46.jpg" },
            { id: 47, alt: "47", link: "47.jpg" },
            { id: 48, alt: "48", link: "48.jpg" },
            { id: 49, alt: "49", link: "49.jpg" },
          ],
        },
        {
          id: 3,
          nameActivity:
            "bienvenida a las personas designadas para integrar los Consejos Distritales en el Proceso Electoral Local Extraordinario 2024-2025",
          subChilden: [
            { id: 50, alt: "50", link: "50.jpg" },
            { id: 51, alt: "51", link: "51.jpg" },
            { id: 52, alt: "52", link: "52.jpg" },
            { id: 53, alt: "53", link: "53.jpg" },
            { id: 54, alt: "54", link: "54.jpg" },
          ],
        },
        {
          id: 4,
          nameActivity:
            "bienvenida y apertura oficial a la capacitación del primer grupo de Supervisoresas Electorales Locales y Capacitadoresas Electorales Locales",
          subChilden: [
            { id: 55, alt: "55", link: "55.jpg" },
            { id: 56, alt: "56", link: "56.jpg" },
            { id: 57, alt: "57", link: "57.jpg" },
            { id: 58, alt: "58", link: "58.jpg" },
          ],
        },
        {
          id: 5,
          nameActivity:
            "calificación de exámenes de personas que integrarán la lista de reserva de CAEL para esta Elección Judicial Local 2025",
          subChilden: [
            { id: 59, alt: "59", link: "59.jpg" },
            { id: 60, alt: "60", link: "60.jpg" },
            { id: 61, alt: "61", link: "61.jpg" },
            { id: 62, alt: "62", link: "62.jpg" },
          ],
        },
        {
          id: 6,
          nameActivity:
            "conferencia “Difusión y promoción de los derechos políticos electorales desde una perspectiva pluricultural”",
          subChilden: [
            { id: 63, alt: "63", link: "63.jpg" },
            { id: 64, alt: "64", link: "64.jpg" },
            { id: 65, alt: "65", link: "65.jpg" },
          ],
        },
        {
          id: 7,
          nameActivity:
            "conferencia “El Proceso Electoral Judicial Local 2025”",
          subChilden: [
            { id: 66, alt: "66", link: "66.jpg" },
            { id: 67, alt: "67", link: "67.jpg" },
            { id: 68, alt: "68", link: "68.jpg" },
            { id: 69, alt: "69", link: "69.jpg" },
          ],
        },
        {
          id: 8,
          nameActivity:
            "Décimo Sexto Parlamento Infantil Tlaxcala 2025",
          subChilden: [
            { id: 70, alt: "70", link: "70.jpg" },
            { id: 71, alt: "71", link: "71.jpg" },
            { id: 72, alt: "72", link: "72.jpg" },
            { id: 73, alt: "73", link: "73.jpg" },
            { id: 74, alt: "74", link: "74.jpg" },
            { id: 75, alt: "75", link: "75.jpg" },
            { id: 76, alt: "76", link: "76.jpg" },
            { id: 77, alt: "77", link: "77.jpg" },
          ],
        },
        {
          id: 9,
          nameActivity:
            "el Consejero Presidente, Consejeras y Consejeros Electorales tomaron la protesta a integrantes de los 6 Consejos Distritales de la Elección Judicial Local 2025",
          subChilden: [
            { id: 78, alt: "78", link: "78.jpg" },
            { id: 79, alt: "79", link: "79.jpg" },
            { id: 80, alt: "80", link: "80.jpg" },
            { id: 81, alt: "81", link: "81.jpg" },
          ],
        },
        {
          id: 10,
          nameActivity:
            "entregar las medidas de seguridad de las boletas electorales que serán utilizadas el próximo 1 de junio de 2025",
          subChilden: [
            { id: 82, alt: "82", link: "82.jpg" },
            { id: 83, alt: "83", link: "83.jpg" },
            { id: 84, alt: "84", link: "84.jpg" },
            { id: 85, alt: "85", link: "85.jpg" },
          ],
        },
        {
          id: 11,
          nameActivity:
            "firma de Convenio de Colaboración, Coordinación y Apoyo Institucional en el marco del Proceso Electoral Local Extraordinario 2024-2025",
          subChilden: [
            { id: 86, alt: "86", link: "86.jpg" },
            { id: 87, alt: "87", link: "87.jpg" },
            { id: 88, alt: "88", link: "88.jpg" },
            { id: 89, alt: "89", link: "89.jpg" },
          ],
        },
        {
          id: 12,
          nameActivity:
            "muestra para simulacro y materiales didácticos y de apoyo para la capacitación de las personas funcionarias de mesa directiva de casilla seccional",
          subChilden: [
            { id: 90, alt: "90", link: "90.jpg" },
            { id: 91, alt: "91", link: "91.jpg" },
            { id: 92, alt: "92", link: "92.jpg" },
            { id: 93, alt: "93", link: "93.jpg" },
            { id: 94, alt: "94", link: "94.jpg" },
          ],
        },
        {
          id: 13,
          nameActivity:
            "revisión de las boletas electorales, previo a su impresión",
          subChilden: [
            { id: 95, alt: "95", link: "95.jpg" },
            { id: 96, alt: "96", link: "96.jpg" },
            { id: 97, alt: "97", link: "97.jpg" },
            { id: 98, alt: "98", link: "98.jpg" },
          ],
        },
        {
          id: 14,
          nameActivity:
            "seguimiento al Servicio de Diseño, Documentación, Implementación, Pruebas y Capacitación del Sistema Informático",
          subChilden: [
            { id: 99, alt: "99", link: "99.jpg" },
            { id: 100, alt: "100", link: "100.jpg" },
            { id: 101, alt: "101", link: "101.jpg" },
            { id: 102, alt: "102", link: "102.jpg" },
          ],
        },
        {
          id: 15,
          nameActivity:
            "Validación de boletas electorales y material electoral",
          subChilden: [
            { id: 103, alt: "103", link: "103.jpg" },
            { id: 104, alt: "104", link: "104.jpg" },
            { id: 105, alt: "105", link: "105.jpg" },
            { id: 106, alt: "106", link: "106.jpg" },
          ],
        },
      ],
    },
    {
      id: 5,
      titleItem: "Mayo",
      children: [
        {
          id: 1,
          nameActivity:
            "banderazo de salida a la distribución de los paquetes electorales a las y los funcionarios de Mesa Directiva de Casilla de esta Elección Judicial 2025",
          subChilden: [
            { id: 107, alt: "107", link: "107.jpg" },
            { id: 108, alt: "108", link: "108.jpg" },
            { id: 109, alt: "109", link: "109.jpg" },
            { id: 110, alt: "110", link: "110.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity:
            "capacitación para la etapa de cómputos",
          subChilden: [
            { id: 111, alt: "111", link: "111.jpg" },
            { id: 112, alt: "112", link: "112.jpg" },
            { id: 113, alt: "113", link: "113.jpg" },
            { id: 114, alt: "114", link: "114.jpg" },
          ],
        },
        {
          id: 3,
          nameActivity:
            "diálogo Ciudadanía y Democracia",
          subChilden: [
            { id: 115, alt: "115", link: "115.jpg" },
            { id: 116, alt: "116", link: "116.jpg" },
            { id: 117, alt: "117", link: "117.jpg" },
            { id: 118, alt: "118", link: "118.jpg" },
          ],
        },
        {
          id: 4,
          nameActivity:
            "instituciones educativas para llevar a cabo la elección juvenil Si yo fuera Presidente por un día",
          subChilden: [
            { id: 119, alt: "119", link: "119.jpg" },
            { id: 120, alt: "120", link: "120.jpg" },
            { id: 121, alt: "121", link: "121.jpg" },
            { id: 122, alt: "122", link: "122.jpg" },
          ],
        },
        {
          id: 5,
          nameActivity:
            "plática informativa titulada “MI PRIMER VOTO-LA IMPORTANCIA DE VOTAR”",
          subChilden: [
            { id: 123, alt: "123", link: "123.jpg" },
            { id: 124, alt: "124", link: "124.jpg" },
            { id: 125, alt: "125", link: "125.jpg" },
          ],
        },
        {
          id: 6,
          nameActivity:
            "sellado y agrupamiento de boletas electorales",
          subChilden: [
            { id: 126, alt: "126", link: "126.jpg" },
            { id: 127, alt: "127", link: "127.jpg" },
            { id: 128, alt: "128", link: "128.jpg" },
          ],
        },
      ],
    },
    {
      id: 5,
      titleItem: "Junio",
      children: [
        
        {
          id: 1,
          nameActivity: "",
          subChilden: [
            { id: 129, alt: "129", link: "129.jpg" },
            { id: 130, alt: "130", link: "130.jpg" },
            { id: 131, alt: "131", link: "131.jpg" },
            { id: 132, alt: "132", link: "132.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity: "",
          subChilden: [{ id: 133, alt: "133", link: "133.jpg" },
          { id: 134, alt: "134", link: "134.jpg" },
          { id: 135, alt: "135", link: "135.jpg" },
          { id: 136, alt: "136", link: "136.jpg" },
          { id: 137, alt: "137", link: "137.jpg" },],
        },
        {
          id: 3,
          nameActivity: "",
          subChilden: [{ id: 138, alt: "138", link: "138.jpg" },
          { id: 139, alt: "139", link: "139.jpg" },
          { id: 140, alt: "140", link: "140.jpg" },
          { id: 141, alt: "141", link: "141.jpg" },
          { id: 142, alt: "142", link: "142.jpg" },
          { id: 143, alt: "143", link: "143.jpg" },
          { id: 144, alt: "144", link: "144.jpg" },
          { id: 145, alt: "145", link: "145.jpg" },],
        },
        {
          id: 4,
          nameActivity: "",
          subChilden: [{ id: 146, alt: "146", link: "146.jpg" },
          { id: 147, alt: "147", link: "147.jpg" },
          { id: 148, alt: "148", link: "148.jpg" },
          { id: 149, alt: "149", link: "149.jpg" },
          { id: 150, alt: "150", link: "150.jpg" },],
        },
        {
          id: 5,
          nameActivity: "",
          subChilden: [{ id: 151, alt: "151", link: "151.jpg" },
          { id: 152, alt: "152", link: "152.jpg" },
          { id: 153, alt: "153", link: "153.jpg" },
          { id: 154, alt: "154", link: "154.jpg" },
      ],
        },
        {
          id: 6,
          nameActivity: "",
          subChilden: [    { id: 155, alt: "155", link: "155.jpg" },
          { id: 156, alt: "156", link: "156.jpg" },
          { id: 157, alt: "157", link: "157.jpg" },
          { id: 158, alt: "158", link: "158.jpg" },],
        },
        {
          id: 7,
          nameActivity: "",
          subChilden: [{ id: 159, alt: "159", link: "159.jpg" },
          { id: 160, alt: "160", link: "160.jpg" },
          { id: 161, alt: "161", link: "161.jpg" },
          { id: 162, alt: "162", link: "162.jpg" },
          { id: 163, alt: "163", link: "163.jpg" },
          { id: 164, alt: "164", link: "164.jpg" },],
        },
        {
          id: 8,
          nameActivity: "",
          subChilden: [{ id: 165, alt: "165", link: "165.jpg" },
          { id: 166, alt: "166", link: "166.jpg" },
          { id: 167, alt: "167", link: "167.jpg" },
          { id: 168, alt: "168", link: "168.jpg" },
          ],
        },
        
      ],
    }
    
  ],
  2024: [
    {
      id: 1,
      titleItem: "Enero",
      children: [
        {
          id: 1,
          nameActivity:
            "Este día aplicamos en tres sedes el examen de conocimientos para aspirantes a integrar los consejos distritales y municipales para el Proceso Electoral",
          subChilden: [
            { id: 1, alt: "1", link: "1.jpg" },
            { id: 2, alt: "2", link: "2.jpg" },
            { id: 3, alt: "3", link: "3.jpg" },
          ],
        },
      ],
    },
    {
      id: 2,
      titleItem: "Febrero",
      children: [
        {
          id: 1,
          nameActivity:
            "Ceremonia de conmemoración del 31 aniversario de la Comisión Estatal de Derechos Humanos de Tlaxcala",
          subChilden: [
            { id: 4, alt: "4", link: "4.jpg" },
            { id: 5, alt: "5", link: "5.jpg" },
            { id: 6, alt: "6", link: "6.jpg" },
          ],
        },
      ],
    },
    {
      id: 3,
      titleItem: "Marzo",
      children: [
        {
          id: 1,
          nameActivity: "15ta. Edición del Parlamento Infantil",
          subChilden: [
            { id: 7, alt: "7", link: "7.jpg" },
            { id: 8, alt: "8", link: "8.jpg" },
            { id: 9, alt: "9", link: "9.jpg" },
            { id: 10, alt: "10", link: "10.jpg" },
          ],
        },
      ],
    },
    {
      id: 4,
      titleItem: "Abril",
      children: [
        {
          id: 1,
          nameActivity: "¡Recibimos boletas de Voto Anticipado!",
          subChilden: [
            { id: 11, alt: "11", link: "11.jpg" },
            { id: 12, alt: "12", link: "12.jpg" },
            { id: 13, alt: "13", link: "13.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity:
            "Aplicación del Examen de Conocimientos para las y los aspirantes para los cargos de SEL y CAEL",
          subChilden: [
            { id: 14, alt: "14", link: "14.jpg" },
            { id: 15, alt: "15", link: "15.jpg" },
            { id: 16, alt: "16", link: "16.jpg" },
          ],
        },
        {
          id: 3,
          nameActivity:
            "Entregamos a los partidos políticos locales la Lista Nominal definitiva que será utilizada por sus representaciones en las casillas el 2 de junio de 2024",
          subChilden: [
            { id: 17, alt: "17", link: "17.jpg" },
            { id: 18, alt: "18", link: "18.jpg" },
          ],
        },
        {
          id: 4,
          nameActivity:
            "Protocolo de personas con discapacidad en el Proceso Electoral Concurrente 2023-2024",
          subChilden: [
            { id: 19, alt: "19", link: "19.jpg" },
            { id: 20, alt: "20", link: "20.jpg" },
            { id: 21, alt: "21", link: "21.jpg" },
          ],
        },
        {
          id: 5,
          nameActivity: "Solicitudes de aspirantes y partidos políticos",
          subChilden: [
            { id: 22, alt: "22", link: "22.jpg" },
            { id: 23, alt: "23", link: "23.jpg" },
            { id: 24, alt: "24", link: "24.jpg" },
          ],
        },
      ],
    },
    {
      id: 5,
      titleItem: "Mayo",
      children: [
        {
          id: 1,
          nameActivity: "Aplicamos el Examen de Conocimientos a personas aspirantes a trabajar en el ITE como Capacitadora Asistente Electoral Local para este Proceso Electoral Local Ordinario 2023-2024",
          subChilden: [
            { id: 25, alt: "25", link: "25.jpg" },
            { id: 26, alt: "26", link: "26.jpg" },
            { id: 27, alt: "27", link: "27.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity: "Capacitamos a las personas seleccionadas en la primera convocatoria como Supervisoras Electorales Locales y Capacitadoras",
          subChilden: [
            { id: 28, alt: "28", link: "28.jpg" },
            { id: 29, alt: "29", link: "29.jpg" },
            { id: 30, alt: "30", link: "30.jpg" },
          ],
        },
        {
          id: 3,
          nameActivity: "el Instituto Tlaxcalteca de Elecciones arrancó la entrega de paquetes electorales del Proceso Electoral Local Ordinario 2023-2024",
          subChilden: [
            { id: 31, alt: "31", link: "31.jpg" },
            { id: 32, alt: "32", link: "32.jpg" },
            { id: 33, alt: "33", link: "33.jpg" },
            { id: 34, alt: "34", link: "34.jpg" },
          ],
        },
        {
          id: 4,
          nameActivity: "ITA, nuestra embajadora del voto salió a animarnos y a tomarse muchas fotos mientras seguimos preparando todo para la jornada electoral",
          subChilden: [
            { id: 35, alt: "35", link: "35.jpg" },
            { id: 36, alt: "36", link: "36.jpg" },
            { id: 37, alt: "37", link: "37.jpg" },
            
          ],
        },
        {
          id: 5,
          nameActivity: "recibimos la totalidad de las boletas para la Jornada Electoral del 2 de junio",
          subChilden: [
            { id: 38, alt: "38", link: "38.jpg" },
            { id: 39, alt: "39", link: "39.jpg" },
            { id: 40, alt: "40", link: "40.jpg" },
          ],
        },
      ],
    },
    {
      id: 6,
      titleItem: "Junio",
      children: [
        {
          id: 1,
          nameActivity:
            "A las 2000 hrs. de este lunes 3 de junio concluyó operaciones el PREP con el 99.78%",
          subChilden: [
            { id: 41, alt: "41", link: "41.jpg" },
            { id: 42, alt: "42", link: "42.jpg" },
            { id: 43, alt: "43", link: "43.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity:
            "Asistencia técnica, jurídica y logística a comunidades que eligen a sus autoridades por el sistema de usos y costumbres",
          subChilden: [
            { id: 44, alt: "44", link: "44.jpg" },
            { id: 45, alt: "45", link: "45.jpg" },
            { id: 46, alt: "46", link: "46.jpg" },
          ],
        },
        {
          id: 3,
          nameActivity:
            "Integrantes de este colegiado emitieron su voto en sus respectivas casillas",
          subChilden: [
            { id: 47, alt: "47", link: "47.jpg" },
            { id: 48, alt: "48", link: "48.jpg" },
            { id: 49, alt: "49", link: "49.jpg" },
            { id: 50, alt: "50", link: "50.jpg" },
            { id: 51, alt: "51", link: "51.jpg" },
            { id: 52, alt: "52", link: "52.jpg" },
          ],
        },
        {
          id: 4,
          nameActivity:
            "Mesa de análisis Reforma al Poder Judicial en México, convocada por el Senado de la República y llevada a cabo este viernes en el Teatro Universitario de la UATX",
          subChilden: [
            { id: 53, alt: "53", link: "53.jpg" },
            { id: 54, alt: "54", link: "54.jpg" },
            { id: 55, alt: "55", link: "55.jpg" },
            { id: 56, alt: "56", link: "56.jpg" },
          ],
        },
        {
          id: 5,
          nameActivity:
            "Revisión y clasificación del material electoral, con el propósito de almacenarlo en las bodegas de material, para su próximo uso",
          subChilden: [
            { id: 57, alt: "57", link: "57.jpg" },
            { id: 58, alt: "58", link: "58.jpg" },
            { id: 59, alt: "59", link: "59.jpg" },
            { id: 60, alt: "60", link: "60.jpg" },
          ],
        },
      ],
    },
    
    {
      id: 7,
      titleItem: "Julio",
      children: [
        {
          id: 1,
          nameActivity:
            "Convenio de colaboración para la conformación de la red interinstitucional de atención integral a mujeres en situación de violencia política",
          subChilden: [
            { id: 61, alt: "61", link: "61.jpg" },
            { id: 62, alt: "62", link: "62.jpg" },
            { id: 63, alt: "63", link: "63.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity:
            "Cumplimiento al acuerdo plenario dictado por el TET para comprobar que se encontraran las actas de escrutinio y cómputo",
          subChilden: [
            { id: 64, alt: "64", link: "64.jpg" },
            { id: 65, alt: "65", link: "65.jpg" },
            { id: 66, alt: "66", link: "66.jpg" },
          ],
        },
        {
          id: 3,
          nameActivity:
            "Parlamento Juvenil 2024 Transparencia Juvenil, Voz que Guía, Política que Inspira",
          subChilden: [
            { id: 67, alt: "67", link: "67.jpg" },
            { id: 68, alt: "68", link: "68.jpg" },
            { id: 69, alt: "69", link: "69.jpg" },
          ],
        },
      ],
      
    },
    {
      id: 8,
      titleItem: "Agosto",
      children: [
        {
          id: 1,
          nameActivity: "“El rol de las juventudes en los cargos de elección popular”",
          subChilden: [
            { id: 70, alt: "70", link: "70.jpg" },
            { id: 71, alt: "71", link: "71.jpg" },
            { id: 72, alt: "72", link: "72.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity:
            "30 aniversario, invitamos a las titularidades de las presidencias de los OPLE a visitar nuestra sede",
          subChilden: [
            { id: 73, alt: "73", link: "73.jpg" },
            { id: 74, alt: "74", link: "74.jpg" },
            { id: 75, alt: "75", link: "75.jpg" },
          ],
        },
        {
          id: 3,
          nameActivity:
            "Brindamos asistencia Técnica, Jurídica y Logística a la comunidades de San Miguel Pipillola, Españita, Santiago Tepeticpac, Totolac, San Francis",
          subChilden: [
            { id: 76, alt: "76", link: "76.jpg" },
            { id: 77, alt: "77", link: "77.jpg" },
            { id: 78, alt: "78", link: "78.jpg" },
            { id: 79, alt: "79", link: "79.jpg" },
          ],
        },
        {
          id: 4,
          nameActivity:
            "Esta mañana el Instituto Tlaxcalteca de Elecciones inauguró la exposición fotográfica “30 años construyendo la democracia” en la galería del Palacio de la Cultura",
          subChilden: [
            { id: 80, alt: "80", link: "80.jpg" },
            { id: 81, alt: "81", link: "81.jpg" },
            { id: 82, alt: "82", link: "82.jpg" },
          ],
        },
        {
          id: 5,
          nameActivity:
            "Nos estamos preparando para brindar asistencia Técnica, Jurídica y Logística a las presidencias de comunidad que eligen a sus autoridades mediante el sistema de usos",
          subChilden: [
            { id: 83, alt: "83", link: "83.jpg" },
            { id: 84, alt: "84", link: "84.jpg" },
          ],
        },
        
      ],
    },
    {
      id: 9,
      titleItem: "Septiembre",
      children: [
        {
          id: 1,
          nameActivity: "concurso de oratoria",
          subChilden: [
            { id: 85, alt: "85", link: "85.jpg" },
            { id: 86, alt: "86", link: "86.jpg" },
            { id: 87, alt: "87", link: "87.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity: "El Domingo 01 de Septiembre del 2024 brindamos asistencia Técnica, Jurídica y Logística a la comunidad de La Trinidad Chimalpa, Totolac que se rige por el sistema de Usos y Costumbres",
          subChilden: [
            { id: 88, alt: "88", link: "88.jpg" },
            { id: 89, alt: "89", link: "89.jpg" },
            { id: 90, alt: "90", link: "90.jpg" },
          ],
        },
      ],
    },
    {
      id: 10,
      titleItem: "Octubre",
      children: [
        {
          id: 1,
          nameActivity: "71 aniversario del sufragio femenino en México",
          subChilden: [
            { id: 91, alt: "91", link: "91.jpg" },
            { id: 92, alt: "92", link: "92.jpg" },
            { id: 93, alt: "93", link: "93.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity: "elecciones escolares",
          subChilden: [
            { id: 94, alt: "94", link: "94.jpg" },
            { id: 95, alt: "95", link: "95.jpg" },
            { id: 96, alt: "96", link: "96.jpg" },
          ],
        },
        {
          id: 3,
          nameActivity: "integrantes de la coalición Sigamos haciendo historia en Tlaxcala",
          subChilden: [
            { id: 97, alt: "97", link: "97.jpg" },
            { id: 98, alt: "98", link: "98.jpg" },
            { id: 99, alt: "99", link: "99.jpg" },
            { id: 100, alt: "100", link: "100.jpg" },
          ],
        },
      ],
    },
    {
      id: 11,
      titleItem: "Noviembre",
      children: [
        {
          id: 1,
          nameActivity:
            "Conferencia “Políticas de prevención y acompañamiento contra la violencia política de género para la construcción de democracias paritarias”",
          subChilden: [
            { id: 101, alt: "101", link: "101.jpg" },
            { id: 102, alt: "102", link: "102.jpg" },
            { id: 103, alt: "103", link: "103.jpg" },
            { id: 104, alt: "104", link: "104.jpg" },
          ],
        },
        {
          id: 2,
          nameActivity:
            "Jornada Electoral de este domingo 24 de noviembre para revisar los últimos detalles de coordinación logística para el traslado de paquetería",
          subChilden: [
            { id: 105, alt: "105", link: "105.jpg" },
            { id: 106, alt: "106", link: "106.jpg" },
            { id: 107, alt: "107", link: "107.jpg" },
          ],
        },
        {
          id: 3,
          nameActivity: "Niña y niño Magistrado Electoral",
          subChilden: [
            { id: 108, alt: "108", link: "108.jpg" },
            { id: 109, alt: "109", link: "109.jpg" },
            { id: 110, alt: "110", link: "110.jpg" },
          ],
        },
        {
          id: 4,
          nameActivity:
            "Para promover el voto en la Jornada Electoral del próximo domingo 24 de Noviembre",
          subChilden: [
            { id: 111, alt: "111", link: "111.jpg" },
            { id: 112, alt: "112", link: "112.jpg" },
            { id: 113, alt: "113", link: "113.jpg" },
            { id: 114, alt: "114", link: "114.jpg" },
          ],
        },
      ],
    },
    
  ],
  
  
  2019: [
    {
      id: 1,
      titleItem: "Mayo 2019",
      children: [
        {
          id: 1,
          nameActivity: "Convención Distrital 8° Parlamento Juvenil",
          dateActivity: "Mayo de 2019",
          subChilden: [
            {
              id: 1,
              alt: "Foto2019_1",
              link: "1.jpg",
            },
            {
              id: 2,
              alt: "Foto2019_2",
              link: "2.jpg",
            },
            {
              id: 3,
              alt: "Foto2019_3",
              link: "3.jpg",
            },
            {
              id: 4,
              alt: "Foto2019_4",
              link: "4.jpeg",
            },
          ],
        },
        {
          id: 2,
          nameActivity: "Convención Distrital 8° Parlamento Juvenil",
          dateActivity: "Mayo de 2019",
          subChilden: [
            {
              id: 1,
              alt: "Foto2019_5",
              link: "5.jpg",
            },
            {
              id: 2,
              alt: "Foto2019_6",
              link: "6.jpg",
            },
            {
              id: 3,
              alt: "Foto2019_7",
              link: "7.jpg",
            },
            {
              id: 4,
              alt: "Foto2019_8",
              link: "8.jpg",
            },
            {
              id: 5,
              alt: "Foto2019_9",
              link: "9.jpg",
            },
            {
              id: 6,
              alt: "Foto2019_10",
              link: "10.jpg",
            },
            {
              id: 7,
              alt: "Foto2019_11",
              link: "11.jpg",
            },
          ],
        },
        {
          id: 3,
          nameActivity: "Curso de Identidad Institucional",
          dateActivity: "Mayo de 2019",
          subChilden: [
            {
              id: 1,
              alt: "Foto2019_12",
              link: "12.jpg",
            },
            {
              id: 2,
              alt: "Foto2019_13",
              link: "13.jpg",
            },
            {
              id: 3,
              alt: "Foto2019_14",
              link: "14.jpg",
            },
            {
              id: 4,
              alt: "Foto2019_15",
              link: "15.jpeg",
            },
          ],
        },
        {
          id: 4,
          nameActivity:
            "Curso Taller: Clasificación y desclasificación de la información",
          dateActivity: "Mayo de 2019",
          subChilden: [
            {
              id: 1,
              alt: "Foto2019_16",
              link: "16.jpg",
            },
            {
              id: 2,
              alt: "Foto2019_17",
              link: "17.jpg",
            },
            {
              id: 3,
              alt: "Foto2019_18",
              link: "18.jpg",
            },
            {
              id: 4,
              alt: "Foto2019_19",
              link: "19.jpg",
            },
            {
              id: 5,
              alt: "Foto2019_20",
              link: "20.jpg",
            },
            {
              id: 6,
              alt: "Foto2019_21",
              link: "21.jpg",
            },
            {
              id: 7,
              alt: "Foto2019_22",
              link: "22.jpg",
            },
            {
              id: 8,
              alt: "Foto2019_23",
              link: "23.jpg",
            },
          ],
        },
        {
          id: 5,
          nameActivity:
            "Los derechos políticos electorales y la participación ciudadana. Conversatorio",
          dateActivity: "20 de Mayo de 2019",
          subChilden: [
            {
              id: 1,
              alt: "Foto2019_24",
              link: "24.jpg",
            },
            {
              id: 2,
              alt: "Foto2019_25",
              link: "25.jpg",
            },
            {
              id: 3,
              alt: "Foto2019_26",
              link: "26.jpg",
            },
            {
              id: 4,
              alt: "Foto2019_27",
              link: "27.jpeg",
            },
            {
              id: 5,
              alt: "Foto2019_28",
              link: "28.jpeg",
            },
            {
              id: 6,
              alt: "Foto2019_29",
              link: "29.jpeg",
            },
            {
              id: 7,
              alt: "Foto2019_30",
              link: "30.jpeg",
            },
          ],
        },
        {
          id: 6,
          nameActivity:
            "Los derechos políticos electorales y la participación ciudadana. Conversatorio",
          dateActivity: "21 de Mayo de 2019",
          subChilden: [
            {
              id: 1,
              alt: "Foto2019_31",
              link: "31.jpg",
            },
            {
              id: 2,
              alt: "Foto2019_32",
              link: "32.jpg",
            },
            {
              id: 3,
              alt: "Foto2019_33",
              link: "33.jpg",
            },
            {
              id: 4,
              alt: "Foto2019_34",
              link: "34.jpeg",
            },
          ],
        },
        {
          id: 7,
          nameActivity: "Reunión en Guadalupe Ixcotla",
          dateActivity: "Mayo de 2019",
          subChilden: [
            {
              id: 1,
              alt: "Foto2019_35",
              link: "35.jpg",
            },
            {
              id: 2,
              alt: "Foto2019_36",
              link: "36.jpg",
            },
            {
              id: 3,
              alt: "Foto2019_37",
              link: "37.jpg",
            },
            {
              id: 4,
              alt: "Foto2019_38",
              link: "38.jpg",
            },
            {
              id: 5,
              alt: "Foto2019_39",
              link: "39.jpg",
            },
            {
              id: 6,
              alt: "Foto2019_40",
              link: "40.jpg",
            },
            {
              id: 7,
              alt: "Foto2019_41",
              link: "41.jpg",
            },
            {
              id: 8,
              alt: "Foto2019_42",
              link: "42.jpg",
            },
            {
              id: 9,
              alt: "Foto2019_43",
              link: "43.jpg",
            },
            {
              id: 10,
              alt: "Foto2019_44",
              link: "44.jpg",
            },
          ],
        },
        {
          id: 8,
          nameActivity:
            "Sesión del Observatorio de Participación Política de las Mujeres en Tlaxcala",
          dateActivity: "Mayo de 2019",
          subChilden: [
            {
              id: 1,
              alt: "Foto2019_45",
              link: "45.jpg",
            },
            {
              id: 2,
              alt: "Foto2019_46",
              link: "46.jpg",
            },
            {
              id: 3,
              alt: "Foto2019_47",
              link: "47.jpg",
            },
            {
              id: 4,
              alt: "Foto2019_48",
              link: "48.jpg",
            },
            {
              id: 5,
              alt: "Foto2019_49",
              link: "49.jpg",
            },
          ],
        },
      ],
    },
    {
      id: 2,
      titleItem: "Junio 2019",
      children: [
        {
          id: 1,
          nameActivity:
            "Curso: Periodismo con perspectiva de género: ética, igualdad y diversidad",
          dateActivity: "Junio de 2019",
          subChilden: [
            {
              id: 1,
              alt: "Foto2019_50",
              link: "50.jpg",
            },
            {
              id: 2,
              alt: "Foto2019_51",
              link: "51.jpg",
            },
            {
              id: 3,
              alt: "Foto2019_52",
              link: "52.jpg",
            },
            {
              id: 4,
              alt: "Foto2019_53",
              link: "53.jpg",
            },
            {
              id: 5,
              alt: "Foto2019_54",
              link: "54.jpg",
            },
            {
              id: 6,
              alt: "Foto2019_55",
              link: "55.jpg",
            },
            {
              id: 7,
              alt: "Foto2019_56",
              link: "56.jpg",
            },
            {
              id: 8,
              alt: "Foto2019_57",
              link: "57.jpg",
            },
            {
              id: 9,
              alt: "Foto2019_58",
              link: "58.jpg",
            },
          ],
        },
        {
          id: 2,
          nameActivity: "Diálogos Juveniles: Cultura Democrática",
          dateActivity: "Junio de 2019",
          subChilden: [
            {
              id: 1,
              alt: "Foto2019_59",
              link: "59.jpg",
            },
            {
              id: 2,
              alt: "Foto2019_60",
              link: "60.jpg",
            },
            {
              id: 3,
              alt: "Foto2019_61",
              link: "61.jpeg",
            },
            {
              id: 4,
              alt: "Foto2019_62",
              link: "62.jpeg",
            },
          ],
        },
        {
          id: 3,
          nameActivity: "Elecciones por Usos y Costumbres - Santa Ana Portales",
          dateActivity: "Junio de 2019",
          subChilden: [
            {
              id: 1,
              alt: "Foto2019_63",
              link: "63.jpg",
            },
            {
              id: 2,
              alt: "Foto2019_64",
              link: "64.jpg",
            },
            {
              id: 3,
              alt: "Foto2019_65",
              link: "65.jpeg",
            },
            {
              id: 4,
              alt: "Foto2019_66",
              link: "66.jpeg",
            },
          ],
        },
        {
          id: 4,
          nameActivity: "Ensayos: Parlamento Juvenil 2019",
          dateActivity: "Junio de 2019",
          subChilden: [
            {
              id: 1,
              alt: "Foto2019_67",
              link: "67.jpg",
            },
            {
              id: 2,
              alt: "Foto2019_68",
              link: "68.jpg",
            },
            {
              id: 3,
              alt: "Foto2019_69",
              link: "69.jpg",
            },
            {
              id: 4,
              alt: "Foto2019_70",
              link: "70.jpg",
            },
            {
              id: 5,
              alt: "Foto2019_71",
              link: "71.jpg",
            },
            {
              id: 6,
              alt: "Foto2019_72",
              link: "72.jpg",
            },
          ],
        },
        {
          id: 5,
          nameActivity: "Rueda de prensa:  Resultados de la Consulta Infantil",
          dateActivity: "Junio de 2019",
          subChilden: [
            {
              id: 1,
              alt: "Foto2019_73",
              link: "73.jpg",
            },
            {
              id: 2,
              alt: "Foto2019_74",
              link: "74.jpg",
            },
            {
              id: 3,
              alt: "Foto2019_75",
              link: "75.jpg",
            },
            {
              id: 4,
              alt: "Foto2019_76",
              link: "76.jpeg",
            },
          ],
        },
      ],
    },
  ],

  2018: [
    {
      id: 1,
      titleItem: "Abril 2018",
      children: [
        {
          id: 1,
          nameActivity: "Convención Estatal 10° Parlamento Infantil 2017",
          dateActivity: "10 de Abril de 2018",
          subChilden: [
            {
              id: 1,
              alt: "Foto2018_1",
              link: "1.jpg",
            },
            {
              id: 2,
              alt: "Foto2018_2",
              link: "2.jpg",
            },
            {
              id: 3,
              alt: "Foto2018_3",
              link: "3.jpg",
            },
            {
              id: 4,
              alt: "Foto2018_4",
              link: "4.jpg",
            },
            {
              id: 5,
              alt: "Foto2018_5",
              link: "5.jpg",
            },
            {
              id: 6,
              alt: "Foto2018_6",
              link: "6.jpg",
            },
            {
              id: 7,
              alt: "Foto2018_7",
              link: "7.jpg",
            },
            {
              id: 8,
              alt: "Foto2018_8",
              link: "8.jpg",
            },
            {
              id: 9,
              alt: "Foto2018_9",
              link: "9.jpg",
            },
            {
              id: 10,
              alt: "Foto2018_10",
              link: "10.jpg",
            },
            {
              id: 11,
              alt: "Foto2018_11",
              link: "11.jpg",
            },
            {
              id: 12,
              alt: "Foto2018_12",
              link: "12.jpg",
            },
            {
              id: 13,
              alt: "Foto2018_13",
              link: "13.jpg",
            },
            {
              id: 14,
              alt: "Foto2018_14",
              link: "14.jpg",
            },
            {
              id: 15,
              alt: "Foto2018_15",
              link: "15.jpg",
            },
            {
              id: 16,
              alt: "Foto2018_16",
              link: "16.jpg",
            },
            {
              id: 17,
              alt: "Foto2018_17",
              link: "17.jpg",
            },
            {
              id: 18,
              alt: "Foto2018_18",
              link: "18.jpg",
            },
            {
              id: 19,
              alt: "Foto2018_19",
              link: "19.jpg",
            },
            {
              id: 20,
              alt: "Foto2018_20",
              link: "20.jpg",
            },
            {
              id: 21,
              alt: "Foto2018_21",
              link: "21.jpg",
            },
            {
              id: 22,
              alt: "Foto2018_22",
              link: "22.jpg",
            },
            {
              id: 23,
              alt: "Foto2018_23",
              link: "23.jpg",
            },
            {
              id: 24,
              alt: "Foto2018_24",
              link: "24.jpg",
            },
            {
              id: 25,
              alt: "Foto2018_25",
              link: "25.jpg",
            },
            {
              id: 26,
              alt: "Foto2018_26",
              link: "26.jpg",
            },
            {
              id: 27,
              alt: "Foto2018_27",
              link: "27.jpg",
            },
            {
              id: 28,
              alt: "Foto2018_28",
              link: "28.jpg",
            },
            {
              id: 29,
              alt: "Foto2018_29",
              link: "29.jpg",
            },
            {
              id: 30,
              alt: "Foto2018_30",
              link: "30.jpg",
            },
            {
              id: 31,
              alt: "Foto2018_31",
              link: "31.jpg",
            },
            {
              id: 32,
              alt: "Foto2018_32",
              link: "32.jpg",
            },
            {
              id: 33,
              alt: "Foto2018_33",
              link: "33.jpg",
            },
            {
              id: 34,
              alt: "Foto2018_34",
              link: "34.jpg",
            },
            {
              id: 35,
              alt: "Foto2018_35",
              link: "35.jpg",
            },
            {
              id: 36,
              alt: "Foto2018_36",
              link: "36.jpg",
            },
            {
              id: 37,
              alt: "Foto2018_37",
              link: "37.jpg",
            },
            {
              id: 38,
              alt: "Foto2018_38",
              link: "38.jpg",
            },
            {
              id: 39,
              alt: "Foto2018_39",
              link: "39.jpg",
            },
            {
              id: 40,
              alt: "Foto2018_40",
              link: "40.jpg",
            },
            {
              id: 41,
              alt: "Foto2018_41",
              link: "41.jpg",
            },
            {
              id: 42,
              alt: "Foto2018_42",
              link: "42.jpg",
            },
            {
              id: 43,
              alt: "Foto2018_43",
              link: "43.jpg",
            },
            {
              id: 44,
              alt: "Foto2018_44",
              link: "44.jpg",
            },
            {
              id: 45,
              alt: "Foto2018_45",
              link: "45.jpg",
            },
          ],
        },
      ],
    },
  ],

  2017: [
    {
      id: 1,
      titleItem: "Marzo 2017",
      children: [
        {
          id: 1,
          nameActivity: "Mesas institucionales de Análisis Electoral",
          dateActivity: "24 de Junio de 2017",
          subChilden: [
            {
              id: 1,
              alt: "Foto2017_1",
              link: "1.jpg",
            },
            {
              id: 2,
              alt: "Foto2017_2",
              link: "2.jpg",
            },
            {
              id: 3,
              alt: "Foto2017_3",
              link: "3.jpg",
            },
            {
              id: 4,
              alt: "Foto2017_4",
              link: "4.jpg",
            },
            {
              id: 5,
              alt: "Foto2017_5",
              link: "5.jpg",
            },
            {
              id: 6,
              alt: "Foto2017_6",
              link: "6.jpg",
            },
            {
              id: 7,
              alt: "Foto2017_7",
              link: "7.jpg",
            },
            {
              id: 8,
              alt: "Foto2017_8",
              link: "8.jpg",
            },
            {
              id: 9,
              alt: "Foto2017_9",
              link: "9.jpg",
            },
            {
              id: 10,
              alt: "Foto2017_10",
              link: "10.jpg",
            },
            {
              id: 11,
              alt: "Foto2017_11",
              link: "11.jpg",
            },
            {
              id: 12,
              alt: "Foto2017_12",
              link: "12.jpg",
            },
            {
              id: 13,
              alt: "Foto2017_13",
              link: "13.jpg",
            },
            {
              id: 14,
              alt: "Foto2017_14",
              link: "14.jpg",
            },
            {
              id: 15,
              alt: "Foto2017_15",
              link: "15.jpg",
            },
            {
              id: 16,
              alt: "Foto2017_16",
              link: "16.jpg",
            },
            {
              id: 17,
              alt: "Foto2017_17",
              link: "17.jpg",
            },
            {
              id: 18,
              alt: "Foto2017_18",
              link: "18.jpg",
            },
            {
              id: 19,
              alt: "Foto2017_19",
              link: "19.jpg",
            },
            {
              id: 20,
              alt: "Foto2017_20",
              link: "20.jpg",
            },
            {
              id: 21,
              alt: "Foto2017_21",
              link: "21.jpg",
            },
            {
              id: 22,
              alt: "Foto2017_22",
              link: "22.jpg",
            },
          ],
        },
        {
          id: 2,
          nameActivity: "Teatro: Ellas en escena AC 'Monólogo'",
          dateActivity: "31 de Marzo de 2017",
          subChilden: [
            {
              id: 1,
              alt: "Foto2017_23",
              link: "23.jpg",
            },
            {
              id: 2,
              alt: "Foto2017_24",
              link: "24.jpg",
            },
            {
              id: 3,
              alt: "Foto2017_25",
              link: "25.jpg",
            },
            {
              id: 4,
              alt: "Foto2017_26",
              link: "26.jpg",
            },
            {
              id: 5,
              alt: "Foto2017_27",
              link: "27.jpg",
            },
            {
              id: 6,
              alt: "Foto2017_28",
              link: "28.jpg",
            },
            {
              id: 7,
              alt: "Foto2017_29",
              link: "29.jpg",
            },
            {
              id: 8,
              alt: "Foto2017_30",
              link: "30.jpg",
            },
            {
              id: 9,
              alt: "Foto2017_31",
              link: "31.jpg",
            },
            {
              id: 10,
              alt: "Foto2017_32",
              link: "32.jpg",
            },
            {
              id: 11,
              alt: "Foto2017_33",
              link: "33.jpg",
            },
            {
              id: 12,
              alt: "Foto2017_34",
              link: "34.jpg",
            },
            {
              id: 13,
              alt: "Foto2017_35",
              link: "35.jpg",
            },
            {
              id: 14,
              alt: "Foto2017_36",
              link: "36.jpg",
            },
            {
              id: 15,
              alt: "Foto2017_37",
              link: "37.jpg",
            },
            {
              id: 16,
              alt: "Foto2017_38",
              link: "38.jpg",
            },
            {
              id: 17,
              alt: "Foto2017_39",
              link: "39.jpg",
            },
            {
              id: 18,
              alt: "Foto2017_40",
              link: "40.jpg",
            },
            {
              id: 19,
              alt: "Foto2017_41",
              link: "41.jpg",
            },
            {
              id: 20,
              alt: "Foto2017_42",
              link: "42.jpg",
            },
            {
              id: 21,
              alt: "Foto2017_43",
              link: "43.jpg",
            },
          ],
        },
      ],
    },
    {
      id: 2,
      titleItem: "Abril 2017",
      children: [
        {
          id: 1,
          nameActivity: "9° Parlamento Infantil 2017",
          dateActivity: "04 de Abril de 2017",
          subChilden: [
            {
              id: 1,
              alt: "Foto2017_43",
              link: "43.jpg",
            },
            {
              id: 2,
              alt: "Foto2017_44",
              link: "44.jpg",
            },
            {
              id: 3,
              alt: "Foto2017_45",
              link: "45.jpg",
            },
            {
              id: 4,
              alt: "Foto2017_46",
              link: "46.jpg",
            },
            {
              id: 5,
              alt: "Foto2017_47",
              link: "47.jpg",
            },
            {
              id: 6,
              alt: "Foto2017_48",
              link: "48.jpg",
            },
            {
              id: 7,
              alt: "Foto2017_49",
              link: "49.jpg",
            },
            {
              id: 8,
              alt: "Foto2017_50",
              link: "50.jpg",
            },
            {
              id: 9,
              alt: "Foto2017_51",
              link: "51.jpg",
            },
            {
              id: 10,
              alt: "Foto2017_52",
              link: "52.jpg",
            },
            {
              id: 11,
              alt: "Foto2017_53",
              link: "53.jpg",
            },
            {
              id: 12,
              alt: "Foto2017_54",
              link: "54.jpg",
            },
            {
              id: 13,
              alt: "Foto2017_55",
              link: "55.jpg",
            },
            {
              id: 14,
              alt: "Foto2017_56",
              link: "56.jpg",
            },
            {
              id: 15,
              alt: "Foto2017_57",
              link: "57.jpg",
            },
            {
              id: 16,
              alt: "Foto2017_58",
              link: "58.jpg",
            },
            {
              id: 17,
              alt: "Foto2017_59",
              link: "59.jpg",
            },
            {
              id: 18,
              alt: "Foto2017_60",
              link: "60.jpg",
            },
            {
              id: 19,
              alt: "Foto2017_61",
              link: "61.jpg",
            },
            {
              id: 20,
              alt: "Foto2017_62",
              link: "62.jpg",
            },
            {
              id: 21,
              alt: "Foto2017_63",
              link: "63.jpg",
            },
            {
              id: 22,
              alt: "Foto2017_64",
              link: "64.jpg",
            },
            {
              id: 23,
              alt: "Foto2017_65",
              link: "65.jpg",
            },
            {
              id: 24,
              alt: "Foto2017_66",
              link: "66.jpg",
            },
            {
              id: 25,
              alt: "Foto2017_67",
              link: "67.jpg",
            },
          ],
        },
        {
          id: 2,
          nameActivity: "Diálogo Democrátivo #2",
          dateActivity: "24 de Abril de 2017",
          subChilden: [
            {
              id: 1,
              alt: "Foto2017_68",
              link: "68.jpg",
            },
            {
              id: 2,
              alt: "Foto2017_69",
              link: "69.jpg",
            },
            {
              id: 3,
              alt: "Foto2017_70",
              link: "70.jpg",
            },
            {
              id: 4,
              alt: "Foto2017_71",
              link: "71.jpg",
            },
            {
              id: 5,
              alt: "Foto2017_72",
              link: "72.jpg",
            },
            {
              id: 6,
              alt: "Foto2017_73",
              link: "73.jpg",
            },
            {
              id: 7,
              alt: "Foto2017_74",
              link: "74.jpg",
            },
            {
              id: 8,
              alt: "Foto2017_75",
              link: "75.jpg",
            },
            {
              id: 9,
              alt: "Foto2017_76",
              link: "76.jpg",
            },
            {
              id: 10,
              alt: "Foto2017_77",
              link: "77.jpg",
            },
            {
              id: 11,
              alt: "Foto2017_78",
              link: "78.jpg",
            },
            {
              id: 12,
              alt: "Foto2017_79",
              link: "79.jpg",
            },
            {
              id: 13,
              alt: "Foto2017_80",
              link: "80.jpg",
            },
          ],
        },
      ],
    },
    {
      id: 3,
      titleItem: "Junio 2017",
      children: [
        {
          id: 1,
          nameActivity: "Jornada Electoral 2017",
          dateActivity: "04 de Junio de 2017",
          subChilden: [
            {
              id: 1,
              alt: "Foto2017_81",
              link: "81.jpg",
            },
            {
              id: 2,
              alt: "Foto2017_82",
              link: "82.jpg",
            },
            {
              id: 3,
              alt: "Foto2017_83",
              link: "83.jpg",
            },
            {
              id: 4,
              alt: "Foto2017_84",
              link: "84.jpg",
            },
            {
              id: 5,
              alt: "Foto2017_85",
              link: "85.jpg",
            },
            {
              id: 6,
              alt: "Foto2017_86",
              link: "86.jpg",
            },
            {
              id: 7,
              alt: "Foto2017_87",
              link: "87.jpg",
            },
            {
              id: 8,
              alt: "Foto2017_88",
              link: "88.jpg",
            },
            {
              id: 9,
              alt: "Foto2017_89",
              link: "89.jpg",
            },
            {
              id: 10,
              alt: "Foto2017_90",
              link: "90.jpg",
            },
            {
              id: 11,
              alt: "Foto2017_91",
              link: "91.jpg",
            },
            {
              id: 12,
              alt: "Foto2017_92",
              link: "92.jpg",
            },
            {
              id: 13,
              alt: "Foto2017_93",
              link: "93.jpg",
            },
            {
              id: 14,
              alt: "Foto2017_94",
              link: "94.jpg",
            },
            {
              id: 15,
              alt: "Foto2017_95",
              link: "95.jpg",
            },
            {
              id: 16,
              alt: "Foto2017_96",
              link: "96.jpg",
            },
            {
              id: 17,
              alt: "Foto2017_97",
              link: "97.jpg",
            },
            {
              id: 18,
              alt: "Foto2017_98",
              link: "98.jpg",
            },
          ],
        },
      ],
    },
    {
      id: 4,
      titleItem: "Julio 2017",
      children: [
        {
          id: 1,
          nameActivity: "6° Parlamento Juvenil 2017",
          dateActivity: "21 de Julio de 2017",
          subChilden: [
            {
              id: 1,
              alt: "Foto2017_99",
              link: "99.jpg",
            },
            {
              id: 2,
              alt: "Foto2017_100",
              link: "100.jpg",
            },
            {
              id: 3,
              alt: "Foto2017_101",
              link: "101.jpg",
            },
            {
              id: 4,
              alt: "Foto2017_102",
              link: "102.jpg",
            },
            {
              id: 5,
              alt: "Foto2017_103",
              link: "103.jpg",
            },
            {
              id: 6,
              alt: "Foto2017_104",
              link: "104.jpg",
            },
            {
              id: 7,
              alt: "Foto2017_105",
              link: "105.jpg",
            },
            {
              id: 8,
              alt: "Foto2017_106",
              link: "106.jpg",
            },
            {
              id: 9,
              alt: "Foto2017_107",
              link: "107.jpg",
            },
            {
              id: 10,
              alt: "Foto2017_108",
              link: "108.jpg",
            },
            {
              id: 11,
              alt: "Foto2017_109",
              link: "109.jpg",
            },
            {
              id: 12,
              alt: "Foto2017_110",
              link: "110.jpg",
            },
            {
              id: 13,
              alt: "Foto2017_111",
              link: "111.jpg",
            },
            {
              id: 14,
              alt: "Foto2017_112",
              link: "112.jpg",
            },
          ],
        },
      ],
    },
    {
      id: 5,
      titleItem: "Agosto 2017",
      children: [
        {
          id: 1,
          nameActivity: "Cómputos Electorales 2017",
          dateActivity: "12 de agosto de 2017",
          subChilden: [
            {
              id: 1,
              alt: "Foto2017_113",
              link: "113.jpg",
            },
            {
              id: 2,
              alt: "Foto2017_114",
              link: "114.jpg",
            },
            {
              id: 3,
              alt: "Foto2017_115",
              link: "115.jpg",
            },
            {
              id: 4,
              alt: "Foto2017_116",
              link: "116.jpg",
            },
            {
              id: 5,
              alt: "Foto2017_117",
              link: "117.jpg",
            },
            {
              id: 6,
              alt: "Foto2017_118",
              link: "118.jpg",
            },
            {
              id: 7,
              alt: "Foto2017_119",
              link: "119.jpg",
            },
            {
              id: 8,
              alt: "Foto2017_120",
              link: "120.jpg",
            },
            {
              id: 9,
              alt: "Foto2017_121",
              link: "121.jpg",
            },
            {
              id: 10,
              alt: "Foto2017_122",
              link: "122.jpg",
            },
            {
              id: 11,
              alt: "Foto2017_123",
              link: "123.jpg",
            },
          ],
        },
      ],
    },
  ],

  2016: [
    {
      id: 1,
      titleItem: "Junio 2016",
      children: [
        {
          id: 1,
          nameActivity:
            "Análisis de Resultados de la Jornada Electoral 2015 - 2016",
          dateActivity: "24 de Junio de 2016",
          subChilden: [
            {
              id: 1,
              alt: "Foto2016_1",
              link: "1.jpg",
            },
            {
              id: 2,
              alt: "Foto2016_2",
              link: "2.jpg",
            },
            {
              id: 3,
              alt: "Foto2016_3",
              link: "3.jpg",
            },
            {
              id: 4,
              alt: "Foto2016_4",
              link: "4.jpg",
            },
            {
              id: 5,
              alt: "Foto2016_5",
              link: "5.jpg",
            },
            {
              id: 6,
              alt: "Foto2016_6",
              link: "6.jpg",
            },
            {
              id: 7,
              alt: "Foto2016_7",
              link: "7.jpg",
            },
            {
              id: 8,
              alt: "Foto2016_8",
              link: "8.jpg",
            },
            {
              id: 9,
              alt: "Foto2016_9",
              link: "9.jpg",
            },
          ],
        },
      ],
    },
    {
      id: 2,
      titleItem: "Julio 2016",
      children: [
        {
          id: 1,
          nameActivity:
            "Entrega de constancias al personal del ITE por su participación en el Proceso Electoral 2015 - 2016",
          dateActivity: "05 de Julio de 2016",
          subChilden: [
            {
              id: 1,
              alt: "Foto2016_10",
              link: "10.jpg",
            },
            {
              id: 2,
              alt: "Foto2016_11",
              link: "11.jpg",
            },
            {
              id: 3,
              alt: "Foto2016_12",
              link: "12.jpg",
            },
            {
              id: 4,
              alt: "Foto2016_13",
              link: "13.jpg",
            },
            {
              id: 5,
              alt: "Foto2016_14",
              link: "14.jpg",
            },
            {
              id: 6,
              alt: "Foto2016_15",
              link: "15.jpg",
            },
            {
              id: 7,
              alt: "Foto2016_16",
              link: "16.jpg",
            },
            {
              id: 8,
              alt: "Foto2016_17",
              link: "17.jpg",
            },
            {
              id: 9,
              alt: "Foto2016_18",
              link: "18.jpg",
            },
            {
              id: 10,
              alt: "Foto2016_19",
              link: "19.jpg",
            },
            {
              id: 11,
              alt: "Foto2016_20",
              link: "20.jpg",
            },
            {
              id: 12,
              alt: "Foto2016_21",
              link: "21.jpg",
            },
            {
              id: 13,
              alt: "Foto2016_22",
              link: "22.jpg",
            },
            {
              id: 14,
              alt: "Foto2016_23",
              link: "23.jpg",
            },
            {
              id: 15,
              alt: "Foto2016_24",
              link: "24.jpg",
            },
            {
              id: 16,
              alt: "Foto2016_25",
              link: "25.jpg",
            },
            {
              id: 17,
              alt: "Foto2016_26",
              link: "26.jpg",
            },
            {
              id: 18,
              alt: "Foto2016_27",
              link: "27.jpg",
            },
            {
              id: 19,
              alt: "Foto2016_28",
              link: "28.jpg",
            },
            {
              id: 20,
              alt: "Foto2016_29",
              link: "29.jpg",
            },
            {
              id: 21,
              alt: "Foto2016_30",
              link: "30.jpg",
            },
            {
              id: 22,
              alt: "Foto2016_31",
              link: "31.jpg",
            },
            {
              id: 23,
              alt: "Foto2016_32",
              link: "32.jpg",
            },
            {
              id: 24,
              alt: "Foto2016_33",
              link: "33.jpg",
            },
            {
              id: 25,
              alt: "Foto2016_34",
              link: "34.jpg",
            },
            {
              id: 26,
              alt: "Foto2016_35",
              link: "35.jpg",
            },
            {
              id: 27,
              alt: "Foto2016_36",
              link: "36.jpg",
            },
            {
              id: 28,
              alt: "Foto2016_37",
              link: "37.jpg",
            },
            {
              id: 29,
              alt: "Foto2016_38",
              link: "38.jpg",
            },
            {
              id: 30,
              alt: "Foto2016_39",
              link: "39.jpg",
            },
            {
              id: 31,
              alt: "Foto2016_40",
              link: "40.jpg",
            },
            {
              id: 32,
              alt: "Foto2016_41",
              link: "41.jpg",
            },
            {
              id: 33,
              alt: "Foto2016_42",
              link: "42.jpg",
            },
            {
              id: 34,
              alt: "Foto2016_43",
              link: "43.jpg",
            },
            {
              id: 35,
              alt: "Foto2016_44",
              link: "44.jpg",
            },
            {
              id: 36,
              alt: "Foto2016_45",
              link: "45.jpg",
            },
            {
              id: 37,
              alt: "Foto2016_46",
              link: "46.jpg",
            },
            {
              id: 38,
              alt: "Foto2016_47",
              link: "47.jpg",
            },
            {
              id: 39,
              alt: "Foto2016_48",
              link: "48.jpg",
            },
            {
              id: 40,
              alt: "Foto2016_49",
              link: "49.jpg",
            },
            {
              id: 41,
              alt: "Foto2016_50",
              link: "50.jpg",
            },
            {
              id: 42,
              alt: "Foto2016_51",
              link: "51.jpg",
            },
            {
              id: 43,
              alt: "Foto2016_52",
              link: "52.jpg",
            },
            {
              id: 44,
              alt: "Foto2016_53",
              link: "53.jpg",
            },
            {
              id: 45,
              alt: "Foto2016_54",
              link: "54.jpg",
            },
          ],
        },
      ],
    },
    {
      id: 3,
      titleItem: "Agosto 2016",
      children: [
        {
          id: 1,
          nameActivity:
            "Entrega ITE constancias a miembros del Parlamento Juvenil 2016",
          dateActivity: "05 de Agosto de 2016",
          subChilden: [
            {
              id: 1,
              alt: "Foto2016_55",
              link: "55.jpg",
            },
            {
              id: 2,
              alt: "Foto2016_56",
              link: "56.jpg",
            },
            {
              id: 3,
              alt: "Foto2016_57",
              link: "57.jpg",
            },
            {
              id: 4,
              alt: "Foto2016_58",
              link: "58.jpg",
            },
            {
              id: 5,
              alt: "Foto2016_59",
              link: "59.jpg",
            },
            {
              id: 6,
              alt: "Foto2016_60",
              link: "60.jpg",
            },
            {
              id: 7,
              alt: "Foto2016_61",
              link: "61.jpg",
            },
            {
              id: 8,
              alt: "Foto2016_62",
              link: "62.jpg",
            },
            {
              id: 9,
              alt: "Foto2016_63",
              link: "63.jpg",
            },
            {
              id: 10,
              alt: "Foto2016_64",
              link: "64.jpg",
            },
            {
              id: 11,
              alt: "Foto2016_65",
              link: "65.jpg",
            },
            {
              id: 12,
              alt: "Foto2016_66",
              link: "66.jpg",
            },
            {
              id: 13,
              alt: "Foto2016_67",
              link: "67.jpg",
            },
            {
              id: 14,
              alt: "Foto2016_68",
              link: "68.jpg",
            },
            {
              id: 15,
              alt: "Foto2016_69",
              link: "69.jpg",
            },
            {
              id: 16,
              alt: "Foto2016_70",
              link: "70.jpg",
            },
            {
              id: 17,
              alt: "Foto2016_71",
              link: "71.jpg",
            },
            {
              id: 18,
              alt: "Foto2016_72",
              link: "72.jpg",
            },
          ],
        },
      ],
    },
    {
      id: 4,
      titleItem: "Septiembre 2016",
      children: [
        {
          id: 1,
          nameActivity:
            "Recuento de 13 de 18 Paquetes de Elección de Ayuntamiento de Tzompantepec",
          dateActivity: "13 de Septimebre de 2016",
          subChilden: [
            {
              id: 1,
              alt: "Foto2016_73",
              link: "73.jpg",
            },
            {
              id: 2,
              alt: "Foto2016_74",
              link: "74.jpg",
            },
            {
              id: 3,
              alt: "Foto2016_75",
              link: "75.jpg",
            },
            {
              id: 4,
              alt: "Foto2016_76",
              link: "76.jpg",
            },
            {
              id: 5,
              alt: "Foto2016_77",
              link: "77.jpg",
            },
            {
              id: 6,
              alt: "Foto2016_78",
              link: "78.jpg",
            },
            {
              id: 7,
              alt: "Foto2016_79",
              link: "79.jpg",
            },
            {
              id: 8,
              alt: "Foto2016_80",
              link: "80.jpg",
            },
          ],
        },
        {
          id: 2,
          nameActivity:
            "Recuento de 86 de 103 paquetes de elección del Distrito 12, con cabecera en Teolocholco",
          dateActivity: "17 de Septimebre de 2016",
          subChilden: [
            {
              id: 1,
              alt: "Foto2016_81",
              link: "81.jpg",
            },
            {
              id: 2,
              alt: "Foto2016_82",
              link: "82.jpg",
            },
            {
              id: 3,
              alt: "Foto2016_83",
              link: "83.jpg",
            },
            {
              id: 4,
              alt: "Foto2016_84",
              link: "84.jpg",
            },
            {
              id: 5,
              alt: "Foto2016_85",
              link: "85.jpg",
            },
            {
              id: 6,
              alt: "Foto2016_86",
              link: "86.jpg",
            },
            {
              id: 7,
              alt: "Foto2016_87",
              link: "87.jpg",
            },
            {
              id: 8,
              alt: "Foto2016_88",
              link: "88.jpg",
            },
            {
              id: 9,
              alt: "Foto2016_89",
              link: "89.jpg",
            },
            {
              id: 10,
              alt: "Foto2016_90",
              link: "90.jpg",
            },
            {
              id: 11,
              alt: "Foto2016_91",
              link: "91.jpg",
            },
            {
              id: 12,
              alt: "Foto2016_92",
              link: "92.jpg",
            },
            {
              id: 13,
              alt: "Foto2016_93",
              link: "93.jpg",
            },
            {
              id: 14,
              alt: "Foto2016_94",
              link: "94.jpg",
            },
            {
              id: 15,
              alt: "Foto2016_95",
              link: "95.jpg",
            },
          ],
        },
      ],
    },
    {
      id: 5,
      titleItem: "Octubre 2016",
      children: [
        {
          id: 1,
          nameActivity: "Conferencia: Sufragio Femennino en México",
          dateActivity: "28 de Octubre de 2016",
          subChilden: [
            {
              id: 1,
              alt: "Foto2016_96",
              link: "96.jpg",
            },
            {
              id: 2,
              alt: "Foto2016_97",
              link: "97.jpg",
            },
            {
              id: 3,
              alt: "Foto2016_98",
              link: "98.jpg",
            },
            {
              id: 4,
              alt: "Foto2016_99",
              link: "99.jpg",
            },
            {
              id: 5,
              alt: "Foto2016_100",
              link: "100.jpg",
            },
            {
              id: 6,
              alt: "Foto2016_101",
              link: "101.jpg",
            },
            {
              id: 7,
              alt: "Foto2016_102",
              link: "102.jpg",
            },
          ],
        },
      ],
    },
  ],
};
